module.exports = __webpack_public_path__ + "img/btn-chevron-left-weak.015f1393.svg";